import React, { useState, useEffect } from 'react';
import '../styles/slideshow.css';

const Slideshow = ({ images }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); // change image every 3 seconds

        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <div className="slideshow-container">
            <div
                className="slideshow-slider"
                style={{ transform: `translateX(-${index * 100}%)` }}
            >
                {images.map((src, i) => (
                    <img
                        key={i}
                        src={src}
                        alt={`Slide ${i + 1}`}
                        className="slide"
                    />
                ))}
            </div>
        </div>
    );
};

export default Slideshow;
